import axios from 'axios';
import { TOKEN } from '@nxsys/store/constants/keys';
import { resolveAuthTarget } from '@nxsys/utils/authTarget';

const apiConfigPublic = axios.create({
  headers: {
    'Content-Type': 'application/json',
  },
});

apiConfigPublic.interceptors.request.use(
  (config) => {
    const { authCode, isBureau } = resolveAuthTarget();

    config.baseURL = isBureau
      ? import.meta.env.VITE_API_URL_BUREAU
      : import.meta.env.VITE_API_URL;

    if (isBureau) {
      config.headers['Accept'] = 'application/vnd.user-backend.v1';
    }

    if (authCode) {
      config.params = {
        auth_code: authCode,
        ...config.params,
      };
    } else {
      const token = localStorage.getItem(TOKEN);
      if (token) {
        config.headers['Authorization'] = `Bearer ${token}`;
      }
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

// Response interceptor: normalize errors and prevent undefined data crashes
apiConfigPublic.interceptors.response.use(
  (response) => response,
  (error) => {
    // Log for debugging (visible in browser console)
    if (import.meta.env.DEV) {
      console.error(
        `[API Error] ${error?.config?.method?.toUpperCase()} ${error?.config?.url}`,
        error?.response?.status,
        error?.response?.data?.message || error?.message,
      );
    }
    return Promise.reject(error);
  },
);

export default apiConfigPublic;
